module.exports = __webpack_public_path__ + "assets/b48.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b48.png
// module id = 636
// module chunks = 0